import React, { Component, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Tooltip, Col, Row, Button, message, Select } from 'antd'
import styles from './tenantInfoDialog.module.scss'
import dayjs from 'dayjs'
import * as apis from '@/apis'
const { Option } = Select;
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },

};

@Form.create()
class InvitationsDialog extends Component {
  state = {
    loading: false,
    invitations: [],
    managers: [],

  }

  handleSubmit = e => {
    const { tenantId, type, modify, row = {}, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      this.setState({ loading: true })
      if (modify !== "modify") {
        apis.createInvitation({
          name: values.name,
          mobile: values.mobile,
          mgroup: values.mgroup,
          type: type,
          tenant_id: tenantId
        }).then(result => {
          this.setState({
            invitations: [result, ...this.state.invitations]
          })
          message.success('已生成')
          this.props.form.resetFields()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        apis.modifyInvitation(row._id, {
          mgroup: values.mgroup,
          // type: type
        }).then(result => {
          message.success('已更新')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })

      }
    });
  }

  fetch = async () => {
    this.setState({ loading: true })
    let invitations
    // 没有判断那个角色 请求分组列表
    const list = await apis.getManagers()
    this.setState({
      managers: list.data || []
    })
    if (this.props.type === 'staff') {
      const result = await apis.getStaffInvitations(this.props.tenantId)
      invitations = result.data

    } else if (this.props.type === 'manager') {
      const result = await apis.getManagerInvitations()
      invitations = result.data
    } else if (this.props.type === 'referral') {
      const result = await apis.getReferralInvitations()
      invitations = result.data
    } else {
      throw new Error('Invalid type:', this.props.type)
    }

    this.setState({
      invitations,
      loading: false
    })
  }

  componentDidMount() {
    this.fetch()
  }

  render() {
    const { type, modify, row = {} } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form
    const columns = [{
      key: '_id',
      title: '姓名',
      render: item => item.name
    }, {
      title: '手机号',
      render: item => item.mobile
    }, {
      title: '分组',
      render: item => item.mgroup.toString()
    }, {
      title: '有效期',
      render: item => dayjs(item.expiredAt).fromNow()
    }, {
      title: '操作',
      render: item => {
        const url = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${item.qr_ticket}`
        const qr = (
          <div>
            <img src={url} width="120" height="120" />
            <center style={{ color: '#ccc' }}>{item.name}</center>
          </div>
        )
        return (
          <div>
            <a>
              <Tooltip
                trigger="click"
                title={qr}>查看邀请码</Tooltip>
            </a>
          </div>
        )
      }
    }]

    const disabled = this.state.invitations.length >= 30 || this.state.loading
    const mingzi = type === 'staff' ? '员工' : '客服'
    const managers = this.state.managers
    return (
      <div>
        <Form
          {...formItemLayout}
          onSubmit={this.handleSubmit}  >
          <Row>
            <Col span={12}>
              {modify !== "modify" ?
                <Form.Item
                  label="姓名"
                  required>
                  {getFieldDecorator('name', {
                    initialValue: row.realname,
                    rules: [
                      {
                        required: true,
                        message: `请输入${mingzi}姓名`,
                      },
                    ],
                  })(
                    <Input disabled={disabled} max={10} autoFocus placeholder={`请输入${mingzi}姓名`} />
                  )}
                </Form.Item> : ""
              }
            </Col>
            <Col span={12}>
              {modify !== "modify" ?
                <Form.Item
                  label="手机号"
                  required>
                  {getFieldDecorator('mobile', {
                    initialValue: row.user?.mobile,
                    rules: [
                      {
                        required: true,
                        message: `请输入${mingzi}手机号`,
                      },
                      {
                        pattern: /^[1]([3-9])[0-9]{9}$/,
                        message: '请输入正确手机号'
                      }
                    ],
                  })(
                    <Input disabled={disabled} max={11} autoFocus placeholder={`请输入${mingzi}手机号`} />
                  )}
                </Form.Item> : ""
              }
            </Col>
          </Row>
          <Row>
            {
              type === 'manager' && (
                <Col span={12}>
                  <Form.Item label="客服分组">
                    {getFieldDecorator('mgroup', {
                      initialValue: row.mgroup?.map(ele => ele._id),
                    })(
                      <Select mode="multiple" allowClear showArrow placeholder={`请输入${mingzi}分组`} >
                        {managers.map(ele => {
                          return <Option key={ele._id} value={ele._id}>{ele.name}</Option>
                        })
                        }
                      </Select>
                    )}
                  </Form.Item>
                </Col>)
            }
          </Row>
          <Form.Item wrapperCol={{
            xs: {
              span: 24,
              offset: 0,
            },
            sm: {
              span: 16,
              offset: 8,
            },
          }}>
            <Button type="primary" disabled={disabled} htmlType="submit"> {modify === "modify" ? "确认修改" : "生成邀请函"}</Button>
          </Form.Item>
        </Form>
        {
          modify !== "modify" ?
            <>
              <Table
                className={styles.table}
                size="small"
                columns={columns}
                pagination={{ pageSize: 5 }}
                rowKey="_id"
                dataSource={this.state.invitations}
                loading={this.state.loading}></Table>
              <p className={styles.tips}>* 只显示有效期内的邀请，最多可同时生30个邀请</p>
            </> : ""
        }
      </div>
    )
  }
}

const TenantInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={680}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <InvitationsDialog onSuccess={hide}  {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'INVITATIONS_DIALOG',
})(TenantInfoDialog)
